import React, { useState, useEffect } from "react";
import Header from "../../components/ui/Header";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";
import Icon from "../../components/AppIcon";
import OrdersTable from "./components/OrderTable";
import OrderFormModal from "./components/OrderFormModal";
import OrderViewModal from "./components/OrderViewModal";
import DeleteConfirmModal from "../users-crud-management/components/DeleteConfirmModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOrderService,
  getOrdersService,
  updateOrderService,
  updateOrderStatusService,
} from "redux/services/orders_service";
import EditOrderStatus from "./components/EditOrderStatus";
import { toast } from "react-toastify";
import ReportModal from "./components/ReportModal";
import { exportOrdersService } from "redux/services/reports_service";
const EnhancedOrdersManagementInterface = () => {
  const dispatch = useDispatch();

  const { ordersList, metaOrders } = useSelector((state) => state.orders);

  const [page, setPage] = useState(1);

  const [language, setLanguage] = useState("ar");
  const [orders, setOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [formMode, setFormMode] = useState("add");
  const [statusFilter, setStatusFilter] = useState("all");
  const [governorateFilter, setGovernorateFilter] = useState("all");
  const [isEditStatusOpen, setIsEditStatusOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "en";
    setLanguage(savedLanguage);
  }, []);

  useEffect(() => {
    dispatch(getOrdersService({ page }));
  }, [page]);

  const handleEditStatusOrder = (order) => {
    setSelectedOrder(order);
    setIsEditStatusOpen(true);
  };

  const handleStatusChange = (orderId, newStatus) => {
    dispatch(
      updateOrderStatusService({ id: orderId, data: { status: newStatus } }),
    ).then((response) => {
      if (response?.payload?.status == 200) {
        toast.success("تم التعديل  بنجاح !");
        dispatch(getOrdersService({ page: 1 }));
      } else {
        Object.values(response.payload.errors)
          .flatMap((errorArray) => errorArray)
          .forEach((error) => toast.warn(error));
      }
    });
  };

  const labels = {
    title: { en: "Orders Management", ar: "إدارة الطلبات" },
    addNew: { en: "Add New Order", ar: "إضافة طلب جديد" },
    search: { en: "Search orders...", ar: "البحث عن الطلبات..." },
    noResults: { en: "No orders found", ar: "لم يتم العثور على طلبات" },
    filterByStatus: { en: "Filter by Status", ar: "تصفية حسب الحالة" },
    filterByGovernorate: {
      en: "Filter by Governorate",
      ar: "تصفية حسب المحافظة",
    },
    allStatuses: { en: "All Statuses", ar: "جميع الحالات" },
    allGovernorates: { en: "All Governorates", ar: "جميع المحافظات" },
    created: { en: "Created", ar: "تم الإنشاء" },
    inProgress: { en: "In Progress", ar: "قيد التنفيذ" },
    completed: { en: "Completed", ar: "مكتمل" },
    cancelled: { en: "Cancelled", ar: "ملغي" },
  };

  const handleAddOrder = () => {
    setFormMode("add");
    setSelectedOrder(null);
    setIsFormModalOpen(true);
  };

  const handleEditOrder = (order) => {
    setFormMode("edit");
    setSelectedOrder(order);
    setIsFormModalOpen(true);
  };

  const handleViewOrder = (order) => {
    setSelectedOrder(order);
    setIsViewModalOpen(true);
  };

  const handleDeleteOrder = (order) => {
    setSelectedOrder(order);
    setIsDeleteModalOpen(true);
  };

  const handleSaveOrder = (data) => {
    dispatch(
      updateOrderService({
        id: selectedOrder.id,
        data: data,
      }),
    ).then((res) => {
      if (res?.payload?.status === 200) {
        toast.success("تم تعديل الطلب بنجاح");
        setIsFormModalOpen(false);
        dispatch(getOrdersService({ page: 1 }));
      } else {
        Object.values(res.payload.errors)
          .flat()
          .forEach((e) => toast.warn(e));
      }
    });
  };

  const handleConfirmDelete = () => {
    dispatch(deleteOrderService(selectedOrder?.id)).then((response) => {
      if (
        response?.payload?.status == 200 ||
        response?.payload?.status == 204
      ) {
        toast("تم الحذف بنجاح");
        setIsDeleteModalOpen(false);
        dispatch(getOrdersService({ page: 1 }));
      }
    });
  };

  return (
    <>
      <div className="min-h-screen bg-background">
        <Header />
        <div className="container mx-auto px-4 py-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-foreground mb-2">
              {labels?.title?.[language]}
            </h1>
          </div>

          <div className="bg-card rounded-xl shadow-elevation-2 border border-border p-6">
            <div className="flex flex-col md:flex-row gap-4 mb-6">
              <div className="flex-1">
                <Input
                  placeholder={labels?.search?.[language]}
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    dispatch(getOrdersService({ search: e.target.value }));
                    setPage(1);
                  }}
                />
              </div>
              <div className="flex gap-3">
                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e?.target?.value)}
                  className="h-10 rounded-md border border-input bg-background px-3 py-2 text-sm"
                >
                  <option value="all">{labels?.allStatuses?.[language]}</option>
                  <option value="CREATED">{labels?.created?.[language]}</option>
                  <option value="IN_PROGRESS">
                    {labels?.inProgress?.[language]}
                  </option>
                  <option value="COMPLETED">
                    {labels?.completed?.[language]}
                  </option>
                  <option value="CANCELLED">
                    {labels?.cancelled?.[language]}
                  </option>
                </select>
                {/*<select
                value={governorateFilter}
                onChange={(e) => setGovernorateFilter(e?.target?.value)}
                className="h-10 rounded-md border border-input bg-background px-3 py-2 text-sm"
              >
                <option value="all">
                  {labels?.allGovernorates?.[language]}
                </option>
                <option value="Baghdad">Baghdad</option>
                <option value="Nineveh">Nineveh</option>
                <option value="Basra">Basra</option>
              </select>*/}
                <Button onClick={() => setIsReportModalOpen(true)}>
                  إصدار تقرير
                </Button>
              </div>
            </div>

            {ordersList?.length === 0 ? (
              <div className="text-center py-12">
                <Icon
                  name="Package"
                  size={48}
                  className="mx-auto text-muted-foreground mb-4"
                />
                <p className="text-lg text-text-secondary">
                  {labels?.noResults?.[language]}
                </p>
              </div>
            ) : (
              <OrdersTable
                orders={ordersList}
                meta={metaOrders}
                page={page}
                setPage={setPage}
                language={language}
                onEdit={handleEditOrder}
                onDelete={handleDeleteOrder}
                onView={handleViewOrder}
                onEditStatus={handleEditStatusOrder}
              />
            )}
          </div>
        </div>

        <OrderFormModal
          isOpen={isFormModalOpen}
          onClose={() => setIsFormModalOpen(false)}
          onSave={handleSaveOrder}
          order={selectedOrder}
          language={language}
        />

        <OrderViewModal
          isOpen={isViewModalOpen}
          onClose={() => setIsViewModalOpen(false)}
          order={selectedOrder}
          language={language}
          onEdit={handleEditOrder}
          onDelete={handleDeleteOrder}
        />

        <DeleteConfirmModal
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          onConfirm={handleConfirmDelete}
          itemName={
            selectedOrder
              ? `${selectedOrder?.firstName} ${selectedOrder?.lastName}`
              : ""
          }
          language={language}
        />

        <EditOrderStatus
          isOpen={isEditStatusOpen}
          onClose={() => setIsEditStatusOpen(false)}
          order={selectedOrder}
          language={language}
          onStatusChange={handleStatusChange}
          onDelete={handleDeleteOrder}
        />
      </div>

      <ReportModal
        isOpen={isReportModalOpen}
        onClose={() => setIsReportModalOpen(false)}
        language={language}
        onSubmit={(data) => {
          console.log("REPORT DATA:", data);

          dispatch(exportOrdersService(data))

          // 👇 هون بتربطه API
          // dispatch(generateReportService(data))

          setIsReportModalOpen(false);
        }}
      />
    </>
  );
};

export default EnhancedOrdersManagementInterface;
